document.addEventListener('DOMContentLoaded', function () {
    var offerSubmissionInput = document.querySelector('input[name="offer_submission_at"]');

    if (!offerSubmissionInput) {
        return;
    }

    function isValidDateFormat(value) {
        var regex = /^\d{2}\.\d{2}\.\d{4} \d{2}:\d{2}$/;
        return regex.test(value);
    }

    function checkDateAndApplyClass() {
        var value = offerSubmissionInput.value;

        // Check if the date format is valid
        if (!isValidDateFormat(value)) {
            offerSubmissionInput.classList.add('is-invalid');
            return;
        }

        // Parse the date and time in the format 'd.m.Y H:i'
        var parts = value.split(' ');
        var dateParts = parts[0].split('.');
        var timeParts = parts[1] ? parts[1].split(':') : [0, 0];

        var selectedDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1]);
        var currentDate = new Date();
        selectedDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        var diffTime = selectedDate - currentDate;
        var diffDays = diffTime / (1000 * 60 * 60 * 24);

        if (diffDays >= 0 && diffDays <= 3) {
            offerSubmissionInput.classList.add('is-invalid');
        } else {
            offerSubmissionInput.classList.remove('is-invalid');
        }
    }

    checkDateAndApplyClass();

    offerSubmissionInput.addEventListener('change', checkDateAndApplyClass);
});
